<template>
  <main>
    <section class="fk-contents">
      <h2 class="title-lv2">{{text.CompleteHeading}}</h2>
      <p class="comp-read" v-html="text.PleaseWait"></p>
      <p class="comp-read">{{$t('Order.AfterReceiving')}}</p>
      <p class="mod-form-btn"><span class="btn-base btn-main" @click.prevent="received($event)">{{$t('Order.Received')}}</span></p>

      <div class="mod-has-label">
        <span class="label">{{text.OrderNumber}}</span>
        <div class="order-num-box">
          <h3 class="order-num">{{model.orderNumber}}</h3>
        </div>
      </div>

      <div class="mod-has-label">
        <span class="label">{{text.ReceiveMethod}}</span>
        <div class="mod-normal-box confirm">
          <h3 class="title-lv3">{{model.receivingMethod.store_name}}<br>{{model.receivingMethod.receiving_method}}</h3>
        </div>
      </div>

      <div class="mod-has-label">
        <span class="label">{{text.OrderDetail}}</span>
        <div class="mod-normal-box">
          <div class="order-detail-wrap">
            <!-- *** 商品 *** -->
            <div class="order-detail-item" v-for="(order, index) in model.orderDetails" :key="index">
              <h3 class="item-coupon-use" v-if="checkUseCoupon(order.coupon_cd)">{{text.UseCoupon}}</h3>
              <h3 class="item-name"><span v-html="order.item_name"></span></h3>
              <div class="quantity">{{text.Quantity}}{{order.quantity}}</div>
              <p class="order-price"><strong>¥{{displayThousandsSeparator(order.price)}}</strong><small>{{model.taxType}}</small></p>
            </div>
            <!-- *** 商品 *** -->
            <!-- *** 会計割引クーポン *** -->
            <div class="order-detail-item" v-if="model.accountingCoupon !== null">
              <h3 class="item-coupon-use">{{text.UseCoupon}}</h3>
              <h3 class="item-name"><span v-html="model.accountingCoupon.name"></span></h3>
              <p class="order-price"><strong>¥{{displayThousandsSeparator(model.accountingCoupon.discount_price)}}</strong><small>{{model.taxType}}</small></p>
            </div>
            <!-- *** 会計割引クーポン *** -->

            <p class="total-price"><small>{{text.Total}}</small><strong>¥{{displayThousandsSeparator(model.totalPrice)}}</strong><small>{{model.taxType}}</small></p>
          </div>
        </div>
      </div>

      <div class="mod-has-label">
        <span class="label">{{text.PaymentMethod}}</span>
        <div class="mod-normal-box confirm">
          <h3 class="title-lv3">{{model.paymentMethod}}</h3>
        </div>
      </div>

      <div class="mod-has-label">
        <span class="label">{{text.ReservedNumber}}</span>
        <div class="mod-normal-box confirm">
          <h3 class="title-lv3">{{model.ReservedNumber}}</h3>
        </div>
      </div>

      <div class="mod-has-label" v-if="model.DPayEnabled">
        <span class="label">{{text.PaymentNumber}}</span>
        <div class="mod-normal-box confirm">
          <h3 class="title-lv3">{{model.PaymentNumber}}</h3>
        </div>
      </div>

      <div class="mod-has-label">
        <span class="label">{{text.PaymentDate}}</span>
        <div class="mod-normal-box confirm">
          <h3 class="title-lv3">{{model.PaymentDate}}</h3>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import {get} from 'lodash'
import CommonMixin from '@/mixins/CommonMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
export default {
  name: 'FKMOOrderComplete',
  mixins: [ CommonMixin, DisplayErrorMixin ],
  data () {
    return {
      model: {
        orderDetails: null,
        orderNumber: null,
        orderDatetime: null,
        receivingMethod: {
          store_name: null,
          receiving_method: null
        },
        totalPrice: null,
        taxType: null,
        paymentMethod: null,
        DPayEnabled: false,
        accountingCoupon: null
      },
      text: {
        CompleteHeading: null,
        PleaseWait: null,
        OrderNumber: null,
        ReceiveMethod: null,
        OrderDetail: null,
        CouponExcluded: null,
        NotApplying: null,
        UseCoupon: null,
        Quantity: null,
        Total: null,
        ReservedNumber: null,
        PaymentNumber: null,
        PaymentDate: null,
        PaymentMethod: null
      }
    }
  },
  computed: {
    getOrderDetail () {
      return this.$store.getters.orderDetail
    },
    getSelectStore () {
      return this.$store.getters.selectStore
    },
    getDisabledButton () {
      return this.$store.getters.disabledButton
    }
  },
  methods: {
    // d払い情報取得
    getDPayInfo: function () {
      this.model.DPayEnabled = this.$store.getters.isDPayEnabled
    },
    checkUseCoupon: function (couponCd) {
      if (couponCd === null || couponCd === undefined || couponCd.length === 0) {
        return false
      }
      return true
    },
    init: function () {
      this.setDisabledButton(true)

      // POSTパラメータを初期化
      let params = {
        order_id: null,
        store_cd: null,
        language: null,
        order_token: null,
        contact_type: null
      }

      // 画面遷移かメールからの遷移かを判定
      if (this.$route.query.order_token === null || this.$route.query.order_token === undefined) {
        // 画面遷移で表示
        params.order_id = this.getOrderDetail.orderId
        params.store_cd = this.getSelectStore.store_cd
        params.language = sessionStorage.getItem('lang')
        params.contact_type = 1
      } else {
        // メールからリンクをたどって表示
        params.order_token = this.$route.query.order_token
        params.language = this.$route.query.language
        params.contact_type = 2
        // MOサイト自身の言語設定変更
        sessionStorage.setItem('lang', params.language)
        this.$i18n.locale = params.language
      }

      // コールバック内参照用
      let _that = this
      this.callApi('OrderComplete',
        params
      )
      // this.axios.get('/static/stub/OrderComplete/order_complete.json')
        .then((res) => {
          if (res.data.result) {
            _that.model.orderDetails = res.data.value.order_details
            _that.model.orderNumber = res.data.value.order_number
            _that.model.orderDatetime = res.data.value.order_datetime
            _that.model.receivingMethod = res.data.value.receiving_method
            _that.model.totalPrice = res.data.value.total_price
            _that.model.taxType = _that.getTaxDisplay(res.data.value.tax_type)
            _that.model.paymentMethod = res.data.value.payment_method
            _that.model.ReservedNumber = get(res.data, 'value.pos_transaction_no', '')
            _that.model.PaymentNumber = get(res.data, 'value.docomo.payment_number', '')
            _that.model.PaymentDate = get(res.data, 'value.order_datetime', '')
            if (res.data.value.accounting_coupon !== null && res.data.value.accounting_coupon !== undefined) {
              _that.model.accountingCoupon = res.data.value.accounting_coupon
            }

            // 表示する商品名を注文明細にassignする
            for (let i = 0; i < res.data.value.display_item_info.length; i++) {
              if (i >= res.data.value.order_details.length) {
                console.error('[FKMO Error]', _that.$i18n.t('ErrorMsg.ERR_911'), res.data.value.order_details, res.data.value.display_item_info)
                break
              }
              _that.model.orderDetails[i] = Object.assign(_that.model.orderDetails[i], res.data.value.display_item_info[i])
            }
          } else {
            _that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch((error) => {
          _that.errorFromAxios(error)
        })
        .finally(() => {
          _that.setDisabledButton(false)
        })
    },
    received: async function (event) {
      if (!(await window.commonConfirm(this.$i18n.t('Order.ReceivedConfirmation')))) {
        // キャンセルを選んだら処理を中断
        return false
      }

      event.preventDefault()
      // 受け取り方法変更フラグを倒す
      sessionStorage.removeItem('changeReceiveMethod')
      sessionStorage.removeItem('changeCartNumber') // 内容変更フラグを倒す

      this.$router.push({ name: this.getHomepage() }, () => {}, () => {})
    },
    initView: function () {
      this.text.CompleteHeading = this.$i18n.t('Order.CompleteHeading')
      this.text.PleaseWait = this.$i18n.t('Order.PleaseWait')
      this.text.OrderNumber = this.$i18n.t('Order.OrderNumber')
      this.text.ReceiveMethod = this.$i18n.t('Cart.ReceiveMethod')
      this.text.OrderDetail = this.$i18n.t('Cart.OrderDetail')
      this.text.CouponExcluded = this.$i18n.t('Cart.CouponExcluded')
      this.text.NotApplying = this.$i18n.t('Cart.NotApplying')
      this.text.UseCoupon = this.$i18n.t('Cart.UseCoupon')
      this.text.Quantity = this.$i18n.t('General.Quantity')
      this.text.Total = this.$i18n.t('General.Total')
      this.text.PaymentMethod = this.$i18n.t('Order.PaymentMethod')
      this.text.ReservedNumber = this.$i18n.t('Order.ReservedNumber')
      this.text.PaymentNumber = this.$i18n.t('Order.PaymentNumber')
      this.text.PaymentDate = this.$i18n.t('Order.PaymentDate')
      // d払い情報取得
      this.getDPayInfo()
    }
  },
  beforeMount () {
    this.init()
  },
  mounted () {
    this.initView()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OrderComplete.vue